import { FormLabel, styled } from "@mui/material";

export const UIFormLabel = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "1.4rem",
  fontWeight: 500,
  marginBottom: "8px",
}));
